import BurritoLogo from "./BurritoLogo";

function MorningAvatar({ className }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="Responsable de la mañana"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="30" fill="#FFF7D9" stroke="#E3A51A" strokeWidth="2" />
      <g fill="none" stroke="#D58B0A" strokeLinecap="round" strokeWidth="3">
        <path d="M32 10v6" />
        <path d="M32 48v6" />
        <path d="m16.4 16.4 4.2 4.2" />
        <path d="m43.4 43.4 4.2 4.2" />
        <path d="M10 32h6" />
        <path d="M48 32h6" />
        <path d="m16.4 47.6 4.2-4.2" />
        <path d="m43.4 20.6 4.2-4.2" />
      </g>
      <circle cx="32" cy="32" r="12" fill="#F6B928" />
      <path d="M25.5 31.5c2.2-2.3 4.4-3.4 6.5-3.4s4.3 1.1 6.5 3.4" fill="none" stroke="#FFF7D9" strokeLinecap="round" strokeWidth="2.5" />
      <circle cx="28" cy="35" r="1.4" fill="#8D5A00" />
      <circle cx="36" cy="35" r="1.4" fill="#8D5A00" />
    </svg>
  );
}

function EveningAvatar({ className }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="Responsable de la tarde"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="30" fill="#EDF1FF" stroke="#5D6FC7" strokeWidth="2" />
      <path
        d="M40.8 43.4A17.5 17.5 0 0 1 24 14.8 19.1 19.1 0 1 0 48.8 39a17.4 17.4 0 0 1-8 4.4Z"
        fill="#5265BE"
      />
      <path d="m43 17 1.5 3.2L48 22l-3.5 1.7L43 27l-1.6-3.3L38 22l3.4-1.8L43 17Z" fill="#F4C95D" />
      <circle cx="50" cy="31" r="2.2" fill="#F4C95D" />
      <circle cx="38" cy="12" r="1.8" fill="#F4C95D" />
    </svg>
  );
}

export default function RoleAvatar({ role, name = "", email = "", className = "w-8 h-8" }) {
  if (role === "admin") {
    return <BurritoLogo className={className} />;
  }

  const identity = `${name} ${email}`.toLocaleLowerCase();
  const isEvening = identity.includes("soir") || identity.includes("moon 2") || identity.includes("moon2");

  return isEvening
    ? <EveningAvatar className={className} />
    : <MorningAvatar className={className} />;
}
